// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Antd = require("antd");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Icons = require("@ant-design/icons");

function LoadingSpinner(Props) {
  var className = Props.className;
  var tmp = {
    indicator: React.createElement(Icons.LoadingOutlined, {
          className: Curry._1(Css.style, {
                hd: Css.fontSize(Css.px(24)),
                tl: /* [] */0
              }),
          spin: true
        })
  };
  if (className !== undefined) {
    tmp.className = className;
  }
  return React.createElement(Antd.Spin, tmp);
}

var make = LoadingSpinner;

exports.make = make;
/* Css Not a pure module */
